<template>
  <div class="postavitev-info" style="padding-top: 40px">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          SMS sporočilo z geslom za povezavo naročnine bo poslano na kontaktno mobilno številko, ki je zavedena v našem
          sistemu pri posamezni naročnini. Če ste mobilno številko spremenili ali so podatki napačni, vas prosimo, da
          nas pokličete na 064 064 064 ali obiščete poslovalnico za posodobitev podatkov.
        </p>
      </div>
    </div>
    <div class="hr-odmik">
      <hr class="hr-stil">
    </div>
    <div class="vsebina">
      <div class="glavna-sekcija">
        <h3 class="naslov">Niste prejeli SMS sporočila?</h3>
        <p>
          Preverite, ali se sporočilo nahaja v mapi z neželeno pošto ali pa je številka pošiljatelja (064 100 100) blokirana.
        </p>
      </div>

      <div class="sekcija">
        <h4 class="naslov">Na napravah z operacijskim sistemom Android (Samsung, Xiaomi ipd.):</h4>
        <ul class="alineje-list">
          <li class="alineja-item">
            Odprite aplikacijo Sporočila, kliknite Meni (:) ali ikono profila in preverite mapo Neželena sporočila (»Neželeno in blokirano« oz. »Spam & blocked«).
          </li>
          <li class="alineja-item">
            Za blokirane številke odprite aplikacijo Telefon, kliknite Meni (:) in izberite Nastavitve > Blokirane številke.
          </li>
        </ul>
      </div>

      <div class="sekcija">
        <h4 class="naslov">Na napravah z operacijskim sistemom iOS (iPhone):</h4>
        <ul class="alineje-list">
          <li class="alineja-item">
            Odprite aplikacijo Messages, kliknite Filters in preverite Unknown Senders.
          </li>
          <li class="alineja-item">
            Blokirane številke najdete v Nastavitve > Telefon > Blokirani stiki.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmsTroubleshooting'
}
</script>

<style scoped>

.hr-odmik {
  padding-top: 30px;
}

.postavitev-info {
  padding-top: 40px;
}

.info-okvir {
  width: 750px;
  height: 120px;
  display: flex;
}

@media only screen and (max-width: 1660px) {
  .info-okvir {
    width: 100%;
    height: 100%;
  }

  .postavitev-info {
    padding-top: 30px;
    padding-bottom: 45px;
  }
}

.vsebina {
  padding-top: 30px;
}

.main-section {
  margin-bottom: 20px;
}

.naslov {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.sekcija {
  margin-bottom: 16px;
}

.sekcija:last-child {
  margin-bottom: 0;
}

.alineje-list {
  margin: 0;
  padding-left: 40px;
  list-style-type: disc;
}

.alineja-item {
  margin-bottom: 6px;
  word-wrap: break-word;
  text-align: justify;
  padding-right: 10px;
}

.alineja-item:last-child {
  margin-bottom: 0;
}

.alineja-item strong {
  font-weight: 600;
  color: #303133;
}

@media (max-width: 768px) {
  .vsebina {
    padding-top: 30px;
  }

  .alineje-list {
    padding-left: 16px;
  }

  .alineja-item {
    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/DodajanjeNarocninKomponente/NavodilaKomponentaDodajanjeNarocnin.vue